import React, { useState, useEffect } from 'react';
import propTypes, { bool } from 'prop-types';
import classNames from 'classnames';
import {
  TextField,
  List,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import ValidationListItem from './ValidationListItem';
import InputButton from '../InputButton';
import {
  passwordValidation,
  passwordLengthValidation,
  passwordLowerValidation,
  passwordUpperValidation,
  passwordCharacterValidation,
  passwordNumberValidation,
} from '../../../utils';
import copies from './copies';
import styles from './PasswordInput.module.css';

const PasswordInput = ({
  id,
  name,
  value,
  onChange,
  label,
  className,
  isSubmitting,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    if (isSubmitting) {
      setShowPassword(false);
    }
  }, [isSubmitting]);
  const isValid = passwordValidation(value);
  return (
    <div className={classNames(styles.container, className)}>
      <TextField
        id={id}
        name={name}
        label={label}
        className={styles.input}
        variant="filled"
        type={showPassword ? 'text' : 'password'}
        value={value}
        error={value.length >= 1 && !isValid}
        onChange={onChange}
        InputProps={{
          endAdornment: (
            <InputButton
              setVisibility={setShowPassword}
              visibility={showPassword}
            />),
          inputProps: { autoComplete: 'off' },
        }}
      />
      {isValid ? (
        <Alert
          severity="success"
          className={styles.successMessage}
        >
          {copies.allDone}
        </Alert>
      ) : (
        <List>
          <ValidationListItem
            text={copies.passwordLengthValidation}
            valid={passwordLengthValidation(value)}
          />
          <ValidationListItem
            text={copies.passwordUpperCaseValidation}
            valid={passwordUpperValidation(value)}
          />
          <ValidationListItem
            text={copies.passwordLowerCaseValidation}
            valid={passwordLowerValidation(value)}
          />
          <ValidationListItem
            text={copies.passwordNumberCaseValidation}
            valid={passwordNumberValidation(value)}
          />
          <ValidationListItem
            text={copies.passwordCharacterValidation}
            valid={passwordCharacterValidation(value)}
          />
        </List>
      )}
    </div>
  );
};
PasswordInput.propTypes = {
  id: propTypes.string.isRequired,
  name: propTypes.string.isRequired,
  value: propTypes.string.isRequired,
  className: propTypes.string,
  label: propTypes.string,
  onChange: propTypes.func,
  isSubmitting: bool,
};

PasswordInput.defaultProps = {
  label: '',
  className: '',
  onChange: () => {},
  isSubmitting: false,
};

export default PasswordInput;
